export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "remarks",
            label: "Remark",
            component: "text-field",
            width: "50%",
          },
          {
            name: "handledBy",
            label: "Handled By", 
            component: "dropdown",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "filePath",
            component: "fileselector",
          },
        ],
        row3: [
          {
            name: "hr",
            component: "hr",
          },
        ],
        row4: [
          {
            name: "sbNo",
            label: "SB No",
            component: "text-field",
            width: "50%",

          },
          {
            name: "sbDate",
            label: "SB Date",
            component: "dateselector",
            width: "50%",

          },
        ],
      },
    },
  ],
};
